import { MeiliSearchError } from "./meilisearch-error.js";
/** Error thrown when a HTTP request times out. */
export class MeiliSearchRequestTimeOutError extends MeiliSearchError {
    name = "MeiliSearchRequestTimeOutError";
    cause;
    constructor(timeout, requestInit) {
        super(`request timed out after ${timeout}ms`);
        this.cause = { timeout, requestInit };
    }
}
